import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-950 border-t border-gray-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Column 1: Lotterics */}
          <div>
            <h3 className="text-white font-bold text-xl mb-3">
              Lotter<span className="text-amber-400">ics</span>
            </h3>
            <p className="text-gray-300 font-semibold mb-2">
              {t('footer.tagline')}
            </p>
            <p className="text-gray-500 text-sm mb-3">
              {t('footer.description')}
            </p>
            <div className="space-y-1.5">
              <Link 
                to="/research"
                className="block text-gray-400 hover:text-amber-400 text-sm transition-colors"
                data-testid="footer-research-link"
              >
                {t('footer.blog')}
              </Link>
            </div>
          </div>

          {/* Column 2: Legal */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-amber-400 text-sm transition-colors"
                >
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms"
                  className="text-gray-400 hover:text-amber-400 text-sm transition-colors"
                >
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/disclaimer"
                  className="text-gray-400 hover:text-amber-400 text-sm transition-colors"
                >
                  {t('footer.disclaimer')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/cookie-policy"
                  className="text-gray-400 hover:text-amber-400 text-sm transition-colors"
                >
                  {t('footer.cookiePolicy')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-gray-400 hover:text-amber-400 text-sm transition-colors"
                >
                  {t('footer.contact')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/about"
                  className="text-gray-400 hover:text-amber-400 text-sm transition-colors"
                >
                  {t('footer.about')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Cultural & Perspectives */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Cultural &amp; Perspectives</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/culture/law-of-attraction"
                  className="text-gray-400 hover:text-amber-400 text-sm transition-colors"
                  data-testid="footer-loa-link"
                >
                  Law of Attraction
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Disclaimer */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">{t('footer.disclaimerTitle')}</h4>
            <p className="text-gray-500 text-sm leading-relaxed">
              {t('footer.disclaimerText')}
            </p>
          </div>

        </div>

        {/* Copyright */}
        <div className="mt-10 pt-6 border-t border-gray-800 text-center">
          <p className="text-gray-600 text-xs">
            © {new Date().getFullYear()} Lotterics. {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
